export const inboxMerged = {
  inboxHeader: 'Kuti postare',
  chatsHeader: 'Bisedat',
  contactsHeader: 'Kontaktet',
  segmentsHeader: 'Grupet',
  ordersHeader: 'Porositë',
  exportStatus: 'Statusi i eksportit',
  tasksExport: 'Detyrat- Eksporti',
  download: 'Shkarko',
  ourAllNewOmniChannelInbox: 'Kuti postare e re e Omni-kanalit tonë të gjitha!',
  allYourMessagesContactsAndLeads: 'Të gjitha mesazhet, kontaktet dhe ledat tuaja tani janë në një vend. Gati për të ndarë dhe grupuar, për të bërë biznesin të rritet!',
  close: 'Mbyll',
  takeALook: 'Jepni një shikim',
  inProgress: 'në vazhdim',
  appTooltip: {
    manageAllYourLeadsHere: 'Menaxhoni të gjitha ledat/të kontaktuarit tuaja këtu',
    segmentYourUserLeads: 'Gruponi ledat/të përdoruesit e botit tuaj bazuar në demografikë dhe interesat. Këto do të përdoren në krijimin e transmetimeve të mesazheve',
    manageAllBotsConversationsHere: 'Menaxhoni të gjitha bisedat e botave këtu',
    manageAllYourOrdersHere: 'Menaxhoni të gjitha porositë tuaja këtu',
  },
  contacts: {
    seeHowToUse: 'Shih si të përdoret',
    help: 'Ndihmë',
    visitorName: 'Emri i vizitorit',
    email: 'Email',
    phoneNumber: 'Numri i telefonit',
    segment: 'Grupi',
    status: 'Statusi',
    tag: 'Etiketë',
    action: 'Veprimi',
    discard: 'Hidh poshtë',
    addTag: 'Shto etiketë',
    loadMore: 'Ngarko më shumë',
    nA: 'E pavlefshme',
    assign: 'Cakto',
    deleteUser: 'Fshi përdoruesin',
    areYouSureToDeleteLead: 'A jeni të sigurt se dëshironi të fshini këtë ledat?',
    twilioIntegrationNeeded: 'Nevojitet Integrimi i Twilio',
    twilioIntegrationNeededDescription: 'Twilio është aktualisht jo i lidhur me skrinin tuaj. Ju lutemi vazhdoni me integrimin për të thirrur klientët tuaj.',
    call: 'Thirrje',
    twilioMakeCall: 'Twilio është integruar me sukses. Tani mund të bëni thirrje te përdoruesit.',
    makeACall: 'Bëni një thirrje',
    integrateNow: 'Integro Tani',
    subscribeUser: 'Abonohu për Përdoruesin',
    unsubscribeUser: 'Ç\'abonohu nga Përdoruesi',
    copy: 'Kopjo',
    noDataFound: {
      youDoNotHaveAnyContactsYet: 'Nuk keni ende kontakte!',
      allOfYourContactsAppearHere: 'Të gjitha kontaktet tuaja do të shfaqen këtu',
    },
    placeholders: {
      searchSegmentByName: 'Kërko grup sipas emrit',
      searchOrAddTag: 'Kërko ose shto një etiketë',
    },
    addContacts: {
      name: 'Emri',
      email: 'Email',
      enterAValidEmail: 'Vendosni një email të vlefshëm',
      phoneNumber: 'Numri i telefonit',
      cancel: 'Anulo',
      addContact: 'Shto Kontakt',
      placeholders: {
        enterEmailAddress: 'Vendosni adresën e emailit',
        enterUserrName: 'Vendosni emrin e përdoruesit',
        searchCountry: 'Kërko vendin',
        enterPhoneNumber: 'Vendosni numrin e telefonit',
      }
    }
  },
  inboxFilter: {
    applied: 'i aplikuar',
    assignTags: 'Cakto etiketat',
    discard: 'Hidh poshtë',
    addTag: 'Shto etiketë',
    assignSegments: 'Cakto grupet',
    filterYourLeads: 'Filtro ledat tuaja',
    filters: 'filtre',
    filter: 'filtr',
    resetAllFilters: 'Rivendos të gjitha filtrat',
    importContacts: 'Importo Kontaktet',
    beforeYouStart: 'Para se të filloni ngarkimin, sigurohuni',
    point1: '1. Shkarkoni skedarin shembull excel.',
    point2: '2. Filloni të vendosni të dhënat tuaja nga rreshti i 2-të dhe më tej.',
    point3: '3. Në secilin rresht, do të ketë të dhënat për një kontakt',
    point4: '4. Sigurohuni që të gjithë numrat e telefonit janë unikë.',
    point5: '5. Kufiri maksimal i madhësisë së skedarit për ngarkim është 20MB',
    selectFile: 'Zgjidh skedarin',
    clickHere: 'Kliko këtu',
    toDownloadSampleFile: 'për të shkarkuar skedarin shembull',
    modal: {
      closeLeads: 'Mbyll Leada',
      areYouSureToselectAllLeads: 'A jeni të sigurt se doni të mbyllni të gjitha ledat e zgjedhura?',
      assignAgent: 'Cakto Agjentin',
      toAssignAgentToAllLeads: 'A jeni të sigurt se doni të caktoni një agjent për të gjitha ledat e zgjedhura?',
      assignTag: 'Cakto Etiketë',
      wantToReplacePreviouslyAssignedTagWithNew: 'A jeni të sigurt se doni të zëvendësoni etiketat e mëparshme të caktuara me atë të reja për të gjitha ledat e zgjedhura?',
      deleteLeads: 'Fshi Leada',
      wantToDeleteSelectedLeads: 'A jeni të sigurt se doni të fshini të gjitha ledat e zgjedhura?',
      exportData: 'Eksporto të dhënat',
      exportDataBasedOn: 'Eksporto të dhënat bazuar në ',
      assignSegment: 'Cakto Grupin',
      wantToAssignSegmentsToSelectedLeads: 'A jeni të sigurt se doni të caktoni një grup për të gjitha ledat e zgjedhura?',
      yesGoAhead: 'Po, vazhdo!',
      export: 'Eksporto'
    },
    appTooltip: {
      filterDataBasedOnPreferences: 'Filtro të dhënat bazuar në preferencat tuaja si etiketat, botin, statusin, etc.',
      markLeadAsClosed: 'Shënimi i përdoruesit/leadt si të mbyllura',
      assignAgentToLead: 'Cakto një agjent për përdoruesin',
      assignTagToUser: 'Cakto etiketë për përdoruesin',
      exportData: 'Eksporto të dhënat',
      importContactsForWhatsappBot: 'Importo kontakte për botin Whatsapp',
      addWhatsappContact: 'Shto kontakte në Whatsapp',
      assignSegmentToUser: 'Cakto grupin për përdoruesin',
      deleteUsers: 'Fshi përdoruesit',
    },
    placeholders: {
      typeNameEmailPhoneNumberAndPressEnter: 'Shkruani emrin, emailin ose numrin e telefonit dhe shtypni Enter',
      searchAgentByName: 'Kërko agjentin sipas emrit',
      searchOrAddTag: 'Kërko ose shto një etiketë',
      searchSegmentByName: 'Kërko grup sipas emrit',
    },
    filterContainer: {
      filterOn: 'Filtro sipas',
      filterBy: 'Filtro nga',
      startFrom: 'Fillo nga',
      tillDate: 'Deri më tani',
      offlineOrOnline: 'Jashtë linje/Online',
      liveChat: 'Bisedë e drejtpërdrejtë',
      userInteractedWithBot: 'Përdoruesi ka ndërvepruar me botin',
      discard: 'Hidh poshtë',
      applyFilter: 'Apliko filtrin',
      bots: 'Botat',
      tags: 'Etiketat',
      status: 'Statusi',
      assignedTo: 'Caktuar te',
      lastMessageBy: 'Zgjedhur nga',
      onlineOrOffline: 'Online/Jashtë linje',
      userInteracted: 'Përdoruesi ka ndërvepruar',
      segments: 'Grupet',
      lastSeenDate: 'Data e fundit e parë',
      onboardingDate: 'Data e regjistrimit',
      createTags: 'Krijo etiketa',
      createTagsToSortAndManageLeads: 'Krijo etiketa për të ndarë dhe menaxhuar ledat tuaja lehtë',
      typeYourTagHere: 'Shkruani etiketën tuaj këtu',
      createSegment: 'Krijo grup',
      manageSegmentForMarketingAutomation: 'Menaxho grupet për automatizimin e marketingut',
      typeYourSegmentHere: 'Shkruani grupin tuaj këtu',
      unSubscribers: 'Jo abonentët',
      unSubscriberUsers: 'Përdoruesit e ç\'abonuar',
      placeholders: {
        searchFilter: 'Kërko filtrin',
        searchByBotName: 'Kërko sipas emrit të botit',
        searchOrAddTag: 'Kërko ose shto një etiketë',
        searchByAgentName: 'Kërko sipas emrit të agjentit',
        searchBySegments: 'Kërko sipas emrit të grupit',
      },
      appTooltip: {
        dateRangeYouWishToEndSelectionAt: 'Zgjidhni periudhën kohore që dëshironi të përfundojë zgjedhjen',
        dateRangeYouWishToStartSelectionFrom: 'Zgjidhni periudhën kohore që dëshironi të fillojë zgjedhjen',
        filterThoseThatAreOfflineOrOnline: 'Filtro përdoruesit që janë jashtë linje/online',
        filterThoseThatAreCurrentlyLiveChatting: 'Filtro përdoruesit që aktualisht bisedojnë në kohë reale',
        filterThoseThatInteractedWithBot: 'Filtro përdoruesit që kanë ndërvepruar me botin',
        filterBySubscribers: 'Filtro sipas statusit të abonentit',
      },
      indexMergeDatePicker: {
        selectStartDate: 'Zgjidh datën e fillimit',
        selectEndDate: 'Zgjidh datën e përfundimit',
      }
    }
  },
  leads: {
    seeHowToUse: 'Shih si të përdoret',
    help: 'Ndihmë',
    visitorName: 'Emri i vizitorit',
    email: 'Email',
    phoneNumber: 'Numri i telefonit',
    assignedTo: 'Caktuar te',
    status: 'Statusi',
    tag: 'Etiketë',
    action: 'Veprimi',
    discard: 'Hidh poshtë',
    addTag: 'Shto etiketë',
    loadMore: 'Ngarko më shumë',
    nA: 'E pavlefshme',
    deleteUsers: 'Fshi përdoruesin',
    areYouSureToDeleteLead: 'A jeni të sigurt se dëshironi të fshini këtë ledat?',
    twilioIntegrationNeeded: 'Nevojitet Integrimi i Twilio',
    twilioIntegrationNeededDescription: 'Twilio është aktualisht jo i lidhur me skrinin tuaj. Ju lutemi vazhdoni me integrimin për të thirrur klientët tuaj.',
    call: 'Thirrje',
    twilioMakeCall: 'Twilio është integruar me sukses. Tani mund të bëni thirrje te përdoruesit.',
    makeACall: 'Bëni një thirrje',
    integrateNow: 'Integro Tani',
    subscribeUser: 'Abonohu për Përdoruesin',
    unsubscribeUser: 'Ç\'abonohu nga Përdoruesi',
    copy: 'Kopjo',
    noDataFound: {
      youDoNotHaveAnyChatsYet: 'Nuk keni ende biseda',
      allOfYourChatsAppearHere: 'Të gjitha bisedat tuaja do të shfaqen këtu',
    },
    placeholders: {
      searchAgentByName: 'Kërko agjentin sipas emrit',
      searchStatusByName: 'Kërko statusin sipas emrit',
      searchOrAddTag: 'Kërko ose shto një etiketë',
    }
  },
  messages: {
    seeHowToUse: 'Shiko si të përdoret',
    help: 'Ndihmë',
    editChatFlow: 'Redakto Fluksin e Bisedës',
    connect: 'Lidhu',
    chat: {
      photo: 'Foto',
      video: 'Video',
      document: 'Dokument',
      location: 'Vendndodhja',
      assignedTo: 'Caktuar te',
      selectBot: 'Zgjidh Botin',
      discard: 'Hidh poshtë',
      addTag: 'Shto Etiketë',
      yourBrowserDoesNotSupportVideoTag: 'Shfletuesi juaj nuk e mbështet etiketën video.',
      userHasSharedADocument: 'Përdoruesi ka ndarë një dokument.',
      clickHereToDownload: 'Kliko këtu për të shkarkuar',
      thisStoryIsNoLongerAvailable: 'Kjo histori nuk është më e disponueshme',
      yourBrowserDoesNotSupportAudioElement: 'Shfletuesi juaj nuk e mbështet elementin audio.',
      thisMessageIsNoLongerAvailable: 'Ky mesazh nuk është më i disponueshëm sepse është çuar prapa nga dërguesi',
      userHasSharedHisLocation: 'Përdoruesi ka ndarë vendndodhjen e tij. Kliko këtu për ta parë',
      sms: 'SMS',
      failed: 'Dështoi',
      a: 'A',
      i: 'I',
      r: 'R',
      m: 'M',
      conversationsSelected: 'bisedat e zgjedhura',
      nA: 'E pavlefshme',
      assignTagsCloseOrBulkReply: 'Cakto etiketat, mbyll ose përgjigju masivisht në një rast',
      twilioIntegrationNeeded: 'Nevojitet Integrimi i Twilio',
      twilioIntegrationNeededDescription: 'Twilio është aktualisht jo i lidhur me skrinin tuaj. Ju lutemi vazhdoni me integrimin për të thirrur klientët tuaj.',
      call: 'Thirrje',
      twilioMakeCall: 'Twilio është integruar me sukses. Tani mund të bëni thirrje te përdoruesit.',
      makeACall: 'Bëni një thirrje',
      integrateNow: 'Integro Tani',
      appTooltip: {
        callUser: 'Thirr përdoruesin',
        assignAgent: 'Cakto agjentin',
        selectBot: 'Zgjidh Botin',
        assignTagsToManageLeads: 'Cakto etiketat për menaxhimin e leadave dhe bisedave',
      },
      placeholders: {
        searchAgentByName: 'Kërko agjentin sipas emrit',
        searchBotByName: 'Kërko botin',
        searchOrAddTag: 'Kërko ose Shto një Etiketë',
        searchStatusByName: 'Kërko statusin sipas emrit',
      }
    },
    profile: {
      userDetails: 'Detajet e Përdoruesit',
      orderDetails: 'Detajet e Porosisë',
      orderedOn: 'Porositur më',
      showMore: 'Shfaq më shumë',
      showLess: 'Shfaq më pak',
      subTotal: 'Nën-totali',
      nA: 'E pavlefshme',
      addAWhatsappNumber: 'Shto Numrin e Whatsapp',
      addTelegramUserName: 'Shto Emrin e Përdoruesit në Telegram',
      addInstagramProfileId: 'Shto ID-në e Profilit në Instagram',
      addFacebookProfileId: 'Shto ID-në e Profilit në Facebook',
      add: 'Shto',
      deviceProperties: 'Karakteristikat e Pajisjes',
      privateNotes: 'Shënime Private',
      urlsVisited: 'URL-të e Vizituara',
      source: 'Burimi - ',
      sourceNa: 'Burimi - NA',
      medium: 'Mesatarja - ',
      mediumNa: 'Mesatarja - NA',
      campaign: 'Kampanja - ',
      campaignNa: 'Kampanja - NA',
      attributeKey: 'Çelësi i Atributit',
      attributeName: 'Emri i Atributit',
      discard: 'Hidh poshtë',
      addAttribute: 'Shto Atribut',
      editAttribute: 'Redakto Atributin',
      deleteAttribute: 'Fshi Atributin',
      headsUp: 'Kujdes',
      areYouSureToDeleteAttribute: 'A jeni të sigurt se dëshironi të fshini këtë atribut?',
      okay: 'Në rregull',
      dataAddedToLead: 'Atributet e mapuara në API-të tuaja nuk do të përditësohen. Ju lutemi, përditësoni API-të sipas nevojave.',
      assignedOnly: 'Vetëm të Caktuarit',
      allUsers: 'Të gjithë Përdoruesit',
      save: 'Ruaj',
      manageCustomAttributes: 'Menaxho Atribute të Personalizuara',
      placeholders: {
        title: 'Titulli',
        egServices: 'P.sh. Shërbimet',
        egRequestedServices: 'P.sh. Shërbimet e Kërkuara',
        enterYourNotesHere: 'Vendosni shënimet tuaja këtu ...'
      },
      bpDropDown: {
        selectBot: 'Zgjidh Botin',
        selectFlow: 'Zgjidh Fluksin',
        selectQuestion: 'Zgjidh Pyetjen*'
      }
    },
    sendMessage: {
      send: 'Dërgo',
      sendToAllChannels: 'Dërgo në të gjitha kanale',
      email: 'Email',
      whatsapp: 'Whatsapp',
      telegram: 'Telegram',
      facebook: 'Facebook',
      sendSms: 'Dërgo SMS',
      addNew: 'Shto të Re',
      addNewQuickReply: 'Shto Përgjigje të Shpejtë të Re',
      discard: 'Hidh poshtë',
      fromComputer: 'Nga Kompjuteri',
      add: 'Shto',
      dragAndDropHereOr: 'Hidh & Zbresko këtu ose',
      browseFiles: 'Shfleto skedarët',
      caption: 'Titulli',
      templates: 'Shabllonet',
      addHeaderMedia: 'Shto media për krye',
      selectFile: 'Zgjidh Skedarin',
      previousConversationClosed: 'Biseda e mëparshme është mbyllur!',
      sendTemplateMessage: 'Dërgo mesazh shablon për të nisur përsëri bisedën.',
      selectTemplate: 'Zgjidh Shabllonin',
      conversationLocked: 'Biseda e bllokuar!',
      demoBotOnlyAllowConversations: 'Boti demo lejon vetëm biseda me numrin që keni verifikuar më parë.',
      unSubscriberUser: 'Përdorues i ç\'abonuar',
      pleaseNoteEither: 'Ju lutemi vini re se ose ky Përdorues është ç\'abonuar ose anasjelltas. Ju lutemi detyroni abonimin për të filluar bisedën.',
      subscribeAndStart: 'Abonohu dhe Fillo',
      placeholders: {
        searchQuickReplyByTitle: 'Kërko Përgjigje të Shpejtë sipas titullit',
        addTitle: 'Shto Titullin',
        addYourRepliesHere: 'Shto përgjigjet tuaja këtu... ',
        addCaption: 'Shto titullin',
        enterValueForThisVariable: 'Vendos vlerën për këtë variabël',
      },
      modal: {
        sendBulkMessages: 'Dërgo Mesazhe Masive',
        send: 'Dërgo',
        description: 'Mesazhi juaj do të pastrohet dhe do të dërgohet bazuar në tipin e platformës ku një përdorues i përket.' +
          '\n - Përdoruesit e faqes së internetit mbështesin vetëm mesazhet bazuar në tekst \n - Kontaktet e Whatsapp (jo të abonuara) mund të marrin vetëm mesazhe shablon'
      },
      noDataFound: {
        oops: 'Ooops!',
        currentlyDoesNotSupportBulkMessages: 'Momentalisht nuk e mbështesim dërgimin masiv të mesazheve për botat Whatsapp. Ju lutemi përdorni veçorinë e transmetimit',
        quickReplies: 'Përgjigje të Shpejta',
        noQuickRepliesAddedYet: 'Ende nuk janë shtuar përgjigje të shpejta!',
      }
    },
    userList: {
      selectAll: 'Zgjidh të Gjithë',
      nA: 'E pavlefshme',
      loadMore: 'Ngarko më shumë',
    }
  },
  segments: {
    seeHowToUse: 'Shiko si të përdoret',
    help: 'Ndihmë',
    manageSegment: 'Menaxho Grupin',
    manageYourSegmentsForMarketingAutomation: 'Menaxho grupet për automatizimin e marketingut',
    createNewSegment: 'Krijo Grup të Ri',
    segmentName: 'Emri i Grupit',
    totalContacts: 'Kontakte të Totalit',
    action: 'Veprimi',
    createSegmentButton: 'Krijo Grup',
    deleteSegments: 'Fshi Grupet',
    areYouSureToDeleteSegment: 'A jeni të sigurt se dëshironi të fshini këtë grup?',
    placeholders: {
      searchHere: 'Kërko këtu',
    },
    noDataFound: {
      youDoNotHaveAnySegmentYet: 'Ende nuk keni krijuar asnjë grup',
      allYourSegmentsAppearHere: 'Të gjitha grupet tuaja do të shfaqen këtu'
    },
    modal: {
      exportData: 'Eksporto të Dhënat',
      exportDataBasedOnAppliedFilters: 'Eksporto të dhënat bazuar në filtrat e aplikuar',
      export: 'Eksporto',
    },
    appTooltip: {
      deleteSegments: 'Fshi grupet',
      editSegment: 'Redakto Grupin',
      downloadSegment: 'Shkarko Grupin',
      deleteSegment: 'Fshi Grupin'
    },
    createSegment: {
      createSegment: 'Krijo grup',
      menaxhoGrupetTuajaPërAutomatiziminEMarketingut: 'Menaxho grupet për automatizimin e marketingut',
      segmentName: 'Emri i Grupit',
      segmentNameIsRequired: 'Emri i Grupit është i detyrueshëm',
      selectContactsFilterForSegment: 'Zgjidh filtrat e kontakteve për Grupin',
      filterYourContacts: 'Filtro kontaktet tuaja',
      removeAllFilters: 'Hiqe të gjitha filtrat',
      addFilters: 'Shto Filtra',
      discard: 'Hidh poshtë',
      filterSelected: 'Filtrat e Zgjedhur',
      placeholders: {
        enterSegmentName: 'Vendos Emrin e Grupit',
      }
    }
  },
  orders: {
    visitorName: 'Emri i Vizitorit',
    email: 'Email',
    phoneNumber: 'Numri i Telefonit',
    status: 'Statusi',
    itemCount: 'Numri i Artikujve',
    total: 'Totali',
    tag: 'Etiketë',
    noDataFound: {
      youDoNotHaveAnyOrdersYet: 'Ende nuk keni asnjë porosi',
      allOfYourOrdersAppearHere: 'Të gjitha porositë tuaja do të shfaqen këtu'
    },
  }
};
